export const AUTHENTICATION__API = {
  AUTHLOGIN: "/auth/login",
  AUTHRESET: "/auth/reset",
  AUTHREGISTER: "/auth/register",
  AUTHCODEVERIFY: "/auth/code-verify",
  AUTHACCOUNTVERIFY: "/auth/account-verify",
  AUTHRESETPASSWORD: "/auth/reset-password",
  AUTHFORGETPASSWORD: "/auth/forget-password",
  AUTHLOGOUT: "/auth/logout",
  SENDREGISTEROTP: "/auth/reg-otp-sent",
  SENTFORGETPASSOTP: "/auth/forget-pass-otp-sent",
  FORGETPASSWORDCODE: "/auth/verify-forget-pass-otp",
};

export const DASHBOARD__API = {
  PARTNERSUMMARY: "/partner-summary",
};

export const PARTNERCOMMISSION__API = {
  PARTNERCOMMISSIONSTATISTICS: "/partner-commission-history",
  PARTNERCOMMISSIONWITHDRAWAL: "/partner-commission-withdrawals",
  PARTNERTRANSFER: "/partner-commission-transfer",
};

export const PROFILE__API = {
  PROFILE: "/profile",
  IDENTITYVERIFICATION: "/profile/identity-verification",
  RESIDENCEVERIFICATION: "/profile/residence-verification",
  FETCHDOCUMENTS: "/profile/clientdocuments",
  CHANGETHEME: "/update-theme",
  GETTUTORIALS: "/get-all-tutorial"
};

export const TRADINGHISTORY__API = {
  CLIENTLIVETRADESREPORTS: "/client-live-trades-reports",
  CLIENTCLOSEDTRADESREPORTS: "/client-closed-trades-reports",
};

export const TRADINGACCTYPES__API = {
  TRADINGACCTYPES: "/trading-account-types",
};

export const CLIENTTRANSACTIONREPORTS__API = {
  TRANSACTIONREPORTS: "/client-transaction-reports",
};

export const FAQS__API = {
  FAQS: "/partner-faqs",
};

export const COMPANYINFO__API = {
  COMPANYINFO: "/company/general-info",
};

export const AGREEMENT__API = {
  NOTACCEPTEDAGREEMENTS: "/fetch-admin-agreements",
  AGREEMENTHISTORIES: "/client-agreements-histories",
  UPLOADAGREEMENTFILE: "/upload-agreement-file",
};

export const ALLACCOUNTSSUMMARY__API = {
  ALLACCOUNTSSUMMARY: "/all-accounts-summary",
  CLINTSSUMMARY: "/client-summary",
};

export const CLIENTTREE__API = {
  CLIENTTREE: "/client-tree",
};

export const DRONEVIEW__API = {
  DRONEVIEW: "/ib-tree",
};

export const PARTNERPROFILE__API = {
  PARTNERPROFILE: "/partner-profile",
};

export const PAYMENTMETHODS__API = {
  PAYMENTMETHODS: "/payment-methods",
};

export const TRADINGACCOUNTSTOTRANSFER__API = {
  TRADINGACCOUNTSTOTRANSFER: "/transfer-commission/trading-accounts",
  INTERNALTRANSFERSENDOTP: "/transfer-commission/send-otp",
  CONFIRMINTERNALTRANSFER: "/confirm-internal-transfer",
  BANKTRANSFERSENDOTP: "/bank-transfer/send-otp",
  CONFIRMBANKTRANSFER: "/confirm-bank-transfer",
  CLIENTLEVELEARNINGS: "/client-level-earnings",
  //crypto tranfer
  ALLCRYPTOADDRESS: "/get-all-crypto-address",
  TRANSFERTOCRYPTOSENDOTP: "/crypto-transfer/send-otp",
  CONFIRMTRANSFERTOCRYPTO: "/confirm-transfer-to-crypto",
  //all tranfer
  ALLBANKADDRESS: "get-all-bank-address",
};

export const COMMISSIONSTATS__API = {
  COMMISSIONSTATS: "/commission-stats-chart",
  LEVELWISECOMMISSIONEARNING: "/levelwise-earning",
};

export const MARKETTINGTOOLS__API = {
  BANNERCATEGORIES: "/banner-categories",
  BANNERSIZES: "/banner-sizes",
  BANNERS: "/banners",
  CREATEBANNER: "/new-banner",
  UPDATEBANNER: "/update-banner",
  DELETEBANNER: "/delete-banner",
  BANNERSIZECREATE: "/create-banner-size",
  BANNERSIZEUPDATE: "/update-banner-size",
  BANNERSIZEDELETE: "/delete-banner-size",
};

export const NOTIFICATIONS__API = {
  NOTIFICATIONS: "/partner-notifications",
  MARK_ALL_AS_READ: "/mark-all-notifications",
  UPDATE: "/mark-as-read",
};

export const ASSACCTYPES__API = {
  ASSIGNEDACCTYPES: "/assigned-account-types",
  CURRENCYGROUPS: "/currency-groups",
  COMRATRESTREE: "/commission-rates/tree",
  VIEWCOMRATRES: "/view-commission-rates/tree",
  UPDATECOMMISSIONRATES: "/partner-details/update-commission-rates/tree",
};

export const PUBLIC_LOGIN__API = {
  LOGINPAGEINFO: "/login-page-info",
};

export const TRADEMASTER__API = {
  INVESTORACCOUNTS: "tm/my-investor-accounts",
  AFFILIATESUMMARY: "tm/affiliate-summary",
  MT5ACCOUNTDETAILS: "tm/mt5-account-details",
  LEVELCLIENTS: "tm/my-level-clients",
  MT5TRANSACTIONS: "tm/mt5-account-transactions"
}
